import { useState } from "react";
import { PRODUCTS } from "@/data/site";
import { ProductGrid } from "@/components/ProductGrid";
import { ProductPrice } from "@/components/ProductPrice";
import { UsageGuide } from "@/components/UsageGuide";

const FeatureCard = ({ product, onOpen, idx }) => (
  <div className="group grid grid-cols-1 md:grid-cols-2 rounded-[2rem] overflow-hidden border border-emerald-900/60 bg-[#06140E]" data-testid={`range-feature-${idx + 1}`}>
    <button type="button" onClick={() => onOpen(product)} className="relative aspect-[4/5] md:aspect-auto md:min-h-[30rem] overflow-hidden bg-[#0B1E16] p-4 flex items-center justify-center" aria-label={`View ${product.name}`}>
      <img src={product.img} alt={product.name} loading="lazy" className="absolute inset-4 w-[calc(100%-2rem)] h-[calc(100%-2rem)] object-contain group-hover:scale-[1.02] transition-transform duration-700" data-testid={`range-feature-image-${idx + 1}`} />
    </button>
    <div className="p-8 lg:p-10 flex flex-col justify-center">
      <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#E5A862]">{product.repair}</span>
      <h3 className="font-condensed text-3xl uppercase text-white mt-2">{product.name}</h3>
      {product.brand && <div className="text-xs text-emerald-300 mt-1">{product.brand}</div>}
      <p className="text-sm text-slate-300 mt-4 leading-relaxed">{product.bestFor}</p>
      <ul className="mt-4 space-y-2">
        {product.benefits.map((b) => (
          <li key={b} className="text-sm text-slate-400 flex items-start gap-2"><span className="text-[#D48C46] mt-0.5">&#10003;</span>{b}</li>
        ))}
      </ul>
      <div className="mt-6 flex flex-wrap items-center gap-4">
        <ProductPrice product={product} size="lg" testId={`range-feature-price-${idx + 1}`} />
        <span className="text-xs text-slate-500">{product.size}</span>
      </div>
      <div className="mt-5">
        <button type="button" onClick={() => onOpen(product)} data-testid={`range-feature-btn-${idx + 1}`} className="px-6 py-3 rounded-xl bg-[#D48C46] hover:bg-[#E5A862] text-slate-950 text-xs font-bold uppercase tracking-wider transition-colors">Details &amp; Order</button>
      </div>
    </div>
  </div>
);

export const ProductRange = () => {
  const [selected, setSelected] = useState(null);
  const featured = PRODUCTS.filter((p) => p.featured);
  return (
    <section id="range" className="py-24 bg-[#030B08]" data-testid="repair-nourish-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <h2 className="font-condensed text-4xl sm:text-5xl uppercase text-white leading-tight">The Zoryven Hair Care Range</h2>
          <p className="mt-5 text-base text-slate-300 leading-relaxed">One routine: cleanse, treat, nourish. Start with the two products our clients ask for most.</p>
        </div>

        <div className="space-y-6">
          {featured.map((p, i) => (
            <FeatureCard key={p.name} product={p} idx={i} onOpen={setSelected} />
          ))}
        </div>

        <div className="mt-20 mb-8 flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-emerald-300">Complete Range</span>
            <h3 className="font-condensed text-3xl uppercase text-white mt-2">The Complete Range</h3>
          </div>
          <p className="text-xs text-slate-400 max-w-sm">Tap any product for ingredients, benefits, how to use and ordering by call or WhatsApp.</p>
        </div>
        <ProductGrid selected={selected} setSelected={setSelected} tone="emerald" />

        <div className="mt-16">
          <UsageGuide tone="emerald" />
        </div>
      </div>
    </section>
  );
};
